import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import Icon from 'components/atomic/Icon';
import Text from 'components/atomic/layouts/Text';

// eslint-disable-next-line react/display-name, react/prop-types, no-unused-vars
const StyledContainer = styled(forwardRef(({ selected, color, ...props }, ref) => <div ref={ref} {...props} />))`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: ${theme.spaces.smallX}px;
  padding-top: ${theme.spaces.small2X}px;
  padding-bottom: ${theme.spaces.small2X}px;
  padding-left: ${theme.spaces.small}px;
  padding-right: ${theme.spaces.small}px;
  border-radius: 8px;
  background: transparent;

  cursor: pointer;

  ${({ selected }) =>
    selected &&
    css`
      background: ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
    `}

  ${({ selected, color }) =>
    selected &&
    color &&
    css`
      background: ${hexToRGBA(color, 0.16)};
    `}
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Tab = ({ tabId, iconAlias, title, selected, color, onSelect }) => {
  const handleSelect = () => {
    onSelect && onSelect(tabId);
  };

  return (
    <StyledContainer color={color} selected={selected === tabId} onClick={handleSelect}>
      <StyledIconContainer>
        <Icon
          alias={iconAlias}
          color={
            selected === tabId
              ? color
                ? color
                : theme.colors.gray.primary
              : color
              ? hexToRGBA(color, 0.64)
              : theme.colors.gray.secondary
          }
          height={20}
          width={20}
        />
      </StyledIconContainer>
      <Text
        size={theme.fontSizes.small}
        weight={500}
        lineHeight={theme.spaces.large}
        color={
          selected === tabId
            ? color
              ? color
              : theme.colors.gray.primary
            : color
            ? hexToRGBA(color, 0.64)
            : theme.colors.gray.secondary
        }
      >
        {title}
      </Text>
    </StyledContainer>
  );
};

Tab.propTypes = {
  tabId: PropTypes.string,
  iconAlias: PropTypes.string,
  title: PropTypes.string,
  selected: PropTypes.string,
  color: PropTypes.string,
  onSelect: PropTypes.func,
};

export default Tab;
